import {createAsyncThunk} from '@reduxjs/toolkit';

import {getCurrentUserId} from 'mattermost-redux/selectors/entities/common';
import {getCurrentTeamId} from 'mattermost-redux/selectors/entities/teams';
import type {AppDispatch} from 'stores/redux_store';
import type {GlobalState} from 'types/store';
import {getUserThreads} from '../api/get_user_threads';

import type {ServerThreads} from '../types/threads';

import {handleReceivedThreads} from './handle_received_threads';

const PAGE_SIZE = 10;

type FulfilledMeta = {teamId: string; pageSize: number};

export const getLatestUserThreads = createAsyncThunk<ServerThreads, void, {fulfilledMeta: FulfilledMeta}>(
    'threads/actions/getLatestUserThreads',
    async (_, thunkAPI) => {
        const dispatch = thunkAPI.dispatch as AppDispatch;
        const state = thunkAPI.getState() as GlobalState;

        const currentUserId = getCurrentUserId(state);
        const currentTeamId = getCurrentTeamId(state);

        const result = await dispatch(
            getUserThreads({
                teamId: currentTeamId,
                userId: currentUserId,
                page: 0,
                pageSize: PAGE_SIZE,
                extended: true,
                skipTotal: true,
                signal: thunkAPI.signal,
            }),
        ).unwrap();

        dispatch(handleReceivedThreads({threads: result.threads, shouldGetMissingProfiles: false}));

        return thunkAPI.fulfillWithValue(result, {teamId: currentTeamId, pageSize: PAGE_SIZE});
    },
);
